import type { AppType } from '@workers/shiboruu-api/src'
import { hc } from 'hono/client'

const resolveApiBaseUrl = (): string => {
  const origin = globalThis.location?.origin
  if (origin && origin !== 'null') return origin

  throw new Error('APIのベースURLを解決できませんでした')
}

const API_BASE_URL = resolveApiBaseUrl()
export const client = hc<AppType>(API_BASE_URL)
